export default __webpack_public_path__ + "static/media/DaveSchrohe-min.f3ff2467.jpeg";